import React from 'react';
import { connect, useSelector } from 'react-redux';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import { clearCartStyles as styles } from './clearCartModal.tailwind';
import Button from '../../Button/Button';
import { clearWholeCart } from '../../../../redux/slices/cartSlice';

const ConfirmRemoveItemModal = ({ isOpen, onClose, clearCart }) => {
  const { cartData, clearingCart } = useSelector((state) => state.cart);
  const { currentSeason } = useSelector(state => state.seasons);
  
  // handle remove item
  const handleRemoveToken = async () => {
    const response = await clearCart({ orderId: cartData._id, seasonId: currentSeason?._id });
    if(clearWholeCart.fulfilled.match(response)){
      onClose();
    }
  }

  return (
    <Modal
      open={isOpen}
      onClose={() => {}} // Prevent closing when clicking outside
      disableAutoFocus
    >
      <div className={styles.container}>
        <button onClick={onClose} className={styles.closeIcon} disabled={clearingCart}>
          <CloseIcon sx={{ fontSize: "18px" }} />
        </button>
        <div className={styles.heading}>Clear Cart</div>
        <div className={styles.description}><span className={styles.confirmationText}>Are you sure you want to clear your cart?</span></div>
        <div className={styles.buttonContainer}>
          <Button variant="primary" onClick={onClose} className={styles.button} disabled={clearingCart}>
            Cancel
          </Button>
          <Button variant="lighttheme" className={styles.cancelButton} onClick={handleRemoveToken} disabled={clearingCart}>
            {clearingCart ? `Clearing...` : `Clear Cart`}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    clearCart: (data) => dispatch(clearWholeCart(data)),
  };
};

export default connect(null, mapDispatchToProps)(ConfirmRemoveItemModal)